module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABZUlEQVRYR+2Wr0sFQRSFvxu0C2IwaBGLWKw2QbRrE7GZFCwGeYo+MGkQDWIUg0URLAazzeKfYDZZzEcW5sEyb/bH7Ntly27bndl7vnvunb1rtHxZy/p0AJ0DjTsgaRo4Bn7M7Mxv+kYBJK0BJ8CyE+77EI0BSDoELryMmweQNO8s3y4ST9ZrdUDSBnAHTJYRrw1A0hjQB44CX9Yh29N7gg5ISrp1Frg2s6+8z7WkJeABWIgVDzrgxE9dsG/g1swuQxCSDoCrDMDczAfvDDkg6QbY94K+AVtm9ps8lzQBPAMro4hnOTAOvALrXvA/YDfRBx5zylIq80wHXIaLwAswFzmuo8RzT4GkTeApAiBavPAYSuoB5yUgKokXArhy3AM7ddW80jCS9JEaKOkYlTPPbUKfUtIM8AlMpdZGFi9VgoGgpFXg3d3XIh4F4PphLxk0oR+LEo0a3FLrNKwC0QF0DnQOtO7AP1FWbSFE4wtWAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/imgs/kfc/check.png
// module id = w3yJ
// module chunks = 1